/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Review_Prompt_PositiveInputs */

const en_mobile_review_prompt_positive = /** @type {(inputs: Mobile_Review_Prompt_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

const es_mobile_review_prompt_positive = /** @type {(inputs: Mobile_Review_Prompt_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí`)
};

/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Mobile_Review_Prompt_PositiveInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_review_prompt_positive = /** @type {((inputs?: Mobile_Review_Prompt_PositiveInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Review_Prompt_PositiveInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_review_prompt_positive(inputs)
	return en_mobile_review_prompt_positive(inputs)
});